import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const getNotificationList = createAsyncThunk("getNotificationList", async (data) => {
    const response = await API.get('auth/notification', data);
    return response.data;
});


export const markNotificationRead = createAsyncThunk("markNotificationRead", async (data) => {
    const response = await API.put('profile/notification/update', data);
    return response.data;
});